import {
  Autocomplete,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Switch,
  Tooltip,
} from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import Zoom from "@mui/material/Zoom";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import AutoComplete from "../components/AutoComplete";
import {
  addCompany_Redux,
  AddContect_Redux,
  Json_GetFolders_Redux,
  portal_Redux,
} from "../redux/ak_api_helper";
import { setOpenCompanyModal } from "../redux/modalSlice";

import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Tab from "@mui/material/Tab";
import dayjs from "dayjs";
import { useLocalStorage } from "../custom-hook/useLocalStorage";
import CreateContect from "../pages/CreateContect";
import { GetAllFolders_Json_Redux } from "../redux/api_helper";
import {
  ad_AddFolders_Toclient_Action,
  ad_ClientAddress_Update_Action,
  ad_Json_CRMSaveUDFValues_Action,
  ad_Json_GetClientAssignedUnassignedFolderList_Action,
  ad_Json_GetClientCardDetails_Action,
  ad_Json_GetConfiguration_Action,
  ad_Json_UpdateClient_Action,
} from "../redux/dev_aditya_action";
import UserUdfEditField from "../user/componants/UserUdfEditField";
import { CountryList } from "../utils/CountryList";
import CompanyChModal from "./CompanyChModal";
import CloseIcon from "@mui/icons-material/Close";
import AcUnitIcon from "@mui/icons-material/AcUnit";
import CreateIcon from "@mui/icons-material/Create";
import DeleteIcon from "@mui/icons-material/Delete";
import InfoIcon from "@mui/icons-material/Info";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const CreateNewComoany = ({
  setCompanyFormData,
  setContactFormData,
  setAllAddressData,
  setUdfFieldChange,
  setCompanyDetailData,
  setAllClientCardData,
  CompanyFormData,
  contactFormData,
  allAddressData,
  udfFieldChange,
  companyDetailData,
  allClientCardData,
}) => {
  const dispatch = useDispatch();
  const handleClose = () => {
    dispatch(setOpenCompanyModal(false));
  };
  const { GetFolders } = useSelector((state) => state.ak);
  const { companyAddress } = useSelector((state) => state.ak);
  const { getClientIdName } = useSelector((state) => state.ak);
  const { getClientIdMethod } = useSelector((state) => state.ak);
  const { getFolderObject } = useSelector((state) => state.ak);
  const { companyCardDitiels, companyCardDitielsAddresses } = useSelector(
    (state) => state.ak
  );
  const { bussiness, sources, mangers, companyStatus, roles } = useSelector(
    (state) => state.ak
  );

  const reqObj = useLocalStorage("required");
  const TabListData = [
    {
      tabIndex: 1,
      tabTile: "Main Address",
    },
    {
      tabIndex: 2,
      tabTile: "Billing Address",
    },
    {
      tabIndex: 3,
      tabTile: "Registered Address",
    },
  ];

  //start editing code for company
  const [value, setValue] = useState("");
  const [manager, setManager] = useState(null);
  const [FolderIdtolabel, setFolderIdtolabel] = useState(null);
  const [textFieldValue, setTextFieldValue] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [storedValue, setStoredValue] = useState("");
  const [selectedFolders, setSelectedFolders] = useState([]);
  const [assignFolders, setAssignFolders] = useState([]);
  const [tabValue, setTabValue] = React.useState("1");
  const [description, setDescription] = React.useState("");
  // const [companyDetailData, setCompanyDetailData] = useState({});
  const [getConfiguration, setGetConfiguration] = useState();
  // const [udfFieldChange, setUdfFieldChange] = useState([]);
  // const [allAddressdata, setAllAddressdata] = useEffect([])
  const [getFolder, setGetFolders] = useState([]);
  // const [allClientCardData, setAllClientCardData] = useState(null);
  const [folderId, setFolderId] = useState(null);
  const [isEmpty, setIsEmpty] = useState(false);
  const [chModalOpen, setChModalOpen] = useState(false);
  // const [allAddressData, setAllAddressData] = useState([
  //   {
  //     Add1: "",
  //     Add2: "",
  //     Add3: "",
  //     Town: "",
  //     County: "",
  //     Postcode: "",
  //     Country: "",
  //   },
  //   {
  //     Add1: "",
  //     Add2: "",
  //     Add3: "",
  //     Town: "",
  //     County: "",
  //     Postcode: "",
  //     Country: "",
  //   },
  //   {
  //     Add1: "",
  //     Add2: "",
  //     Add3: "",
  //     Town: "",
  //     County: "",
  //     Postcode: "",
  //     Country: "",
  //   },
  // ]);

  // const [CompanyFormData, setCompanyFormData] = useState({
  //   ID: "",
  //   Name: "",
  //   TelPhoneNo: "",
  //   Town: "",
  //   MobileNo: "",
  //   contactEmail: "",
  //   "Post Code": "",
  //   "Address Line 1": "",
  //   "Address Line 2": "",
  //   "Address Line 3": "",
  //   status: "",
  //   PassWord: "",
  //   Manager: "",
  //   County: "",
  //   Country: "",
  //   Business: "",
  //   Source: "",
  //   Folder: [],
  //   OriginatorNo: getClientIdMethod,
  // });

  // const [contactFormData, setContactFormData] = React.useState({
  //   Add1: "",
  //   Add2: "",
  //   Add3: "",
  //   AssignedManager: 1,
  //   CActive: "Yes",
  //   CCode: "",
  //   Country: "",
  //   Email: reqObj.Email,
  //   FirstName: "",
  //   LastName: "",
  //   ManagerName: "",
  //   Mobile: "",
  //   PostCode: "",
  //   email: "",
  //   Role: "",
  //   Salutation: "",
  //   Tel: "",
  //   Town: "",
  //   accid: reqObj.agrno,
  //   agrno: reqObj.agrno,
  //   greeting: "",
  //   maincontact: false,
  //   note: "",
  //   password: reqObj.password,
  //   Company: "",
  //   Title: "",
  // });

  let body = {
    strOrignatorNumber: CompanyFormData?.ID || "",
    intProjectId: getFolderObject,
  };

  useEffect(() => {
    if (folderId) {
      let newBody = {
        strOrignatorNumber: CompanyFormData?.ID || "",
        intProjectId: folderId?.FolderID,
      };
      dispatch(
        ad_Json_GetClientCardDetails_Action(newBody, (res) => {
          if (udfFieldChange && udfFieldChange.length > 0) {
            udfFieldChange.forEach((udfFieId) => {});
          }
          setAllClientCardData(res);
        })
      );
    }
  }, [folderId]);

  function todayDate() {
    var today = new Date().toJSON().slice(0, 10);
    return today;
  }

  const getAssignFolder = () => {
    dispatch(
      ad_Json_GetClientAssignedUnassignedFolderList_Action(
        { strOrignatorno: body.strOrignatorNumber },
        (res) => {
          setAssignFolders(res?.Table);
        }
      )
    );
  };
  //  address functions start
  const onHandleChange = (e, index, field) => {
    const { value } = e.target;
    setAllAddressData((prevData) =>
      prevData.map((address, i) =>
        i === index ? { ...address, [field]: value } : address
      )
    );
  };

  useEffect(() => {
    if (allAddressData[0]) {
      const formattedAddress = [
        allAddressData[0].Add1,
        allAddressData[0].Add2,
        allAddressData[0].Add3,
        allAddressData[0].Town,
        allAddressData[0].County,
        allAddressData[0].Postcode,
        allAddressData[0].Country,
      ]
        .filter((value) => value) // Exclude empty values
        .join("\n"); // Join values with a comma
      setDescription(formattedAddress);
    }
  }, [allAddressData]);
  // address function finish
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleFnameInputChange = (event) => {
    const { name, value } = event.target;
    setCompanyFormData({ ...CompanyFormData, [name]: value });
  };

  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");

  useEffect(() => {
    if (Object.keys(companyCardDitiels).length === 0) setIsEmpty(true);
    if (Object.keys(companyDetailData).length === 0) setIsEmpty(true);
  }, [companyCardDitiels, companyDetailData]);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleEmailChange1 = (event) => {
    const newEmail = event.target.value;
    const { name, value } = event.target;
    setCompanyFormData({ ...CompanyFormData, [name]: value });
    setEmail(newEmail);
    if (validateEmail(newEmail)) {
      setEmailError("");
    } else {
      setEmailError("Invalid email address");
    }
  };

  const handleChange = (event) => {
    const inputValue = event.target.value;
    const { name, value } = event.target;
    setCompanyFormData({ ...CompanyFormData, [name]: value });
    setContactFormData({ ...contactFormData, Company: value });

    if (
      value.includes(CompanyFormData.ID) ||
      event.nativeEvent.inputType === "deleteContentBackward"
    ) {
      setIsChecked(false);
    }
  };

  React.useEffect(() => {
    if (isChecked) {
      setStoredValue(" " + textFieldValue);
    } else {
      setStoredValue("");
    }
  }, [isChecked, textFieldValue]);

  React.useEffect(() => {
    if (storedValue && value.includes(storedValue)) {
      setValue(value.replace(storedValue, ""));
    }
  }, [storedValue, value]);

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
    if (event.target.checked) {
      if (!CompanyFormData.Name.includes(` ${CompanyFormData.ID}`)) {
        setCompanyFormData({
          ...CompanyFormData,
          Name: `${CompanyFormData.Name.trim()}   ${CompanyFormData.ID}`,
        });
      }
    } else {
      setCompanyFormData({
        ...CompanyFormData,
        // Name: CompanyFormData.Name.split(" ").slice(0, -1).join(" ").toString(),
        Name: CompanyFormData.Name.replace(` ${CompanyFormData.ID}`, " "),
      });
    }
  };

  const handleTextFieldChange = (event) => {
    const { name, value } = event.target;
    const regex = /^[a-zA-Z0-9-]*$/; // Regex to allow only letters, numbers, and hyphens

    if (isChecked && CompanyFormData.ID.trim().length > 0) {
      console.log("✌️CompanyFormData.ID --->", isChecked, CompanyFormData.ID);

      // Remove ID from Name and append new value
      const nameWithoutID = CompanyFormData.Name.replace(
        CompanyFormData.ID,
        ""
      ).trim();
      const updatedName = `${nameWithoutID}  ${value}`.trim(); // Avoid extra spaces
      console.log("✌️Updated Name --->", updatedName);

      // Update CompanyFormData with the new Name
      setCompanyFormData((prevData) => ({
        ...prevData,
        Name: updatedName, // Set the new modified name
      }));
    }

    // Update individual field if it passes the regex test
    if (regex.test(value)) {
      setTextFieldValue(value);
      setCompanyFormData((prevData) => ({ ...prevData, [name]: value }));
    }
  };

  React.useEffect(() => {
    dispatch(Json_GetFolders_Redux());
    dispatch(
      ad_Json_GetConfiguration_Action((res) => {
        setGetConfiguration(res);
        const manager = res?.Table3.find(
          (man) => Number(man.UserId) === Number(localStorage.getItem("UserId"))
        );
        setCompanyFormData({
          ...CompanyFormData,
          status: res?.Table[0],
          Business: res?.Table1[0],
          Source: res?.Table2[0],
          Manager: manager,
        });
        setManager(manager);
      })
    );
    // getAssignFolder();
    dispatch(
      GetAllFolders_Json_Redux(function (res) {
        if (res) {
          setGetFolders(res);
          setSelectedFolders([res[0]]);
          setFolderId(res[0]);
          handleChange1([res[0]]);
          // setFolderId(
          //   res.length > 0
          //     ? res.find(
          //         (option) =>
          //           Number(option?.FolderID) === Number(getFolderObject)
          //       )
          //     : null
          // );
        }
      })
    );
  }, [dispatch]);

  const handleChange1 = (newValue) => {
    console.log("✌️newValue --->", newValue);
    setSelectedFolders(newValue);
    // event.preventDefault();
    if (newValue) {
      const folderIds = newValue.map((folder) => folder.FolderID).join(",");
      setCompanyFormData({ ...CompanyFormData, Folder: folderIds });
    }
  };

  const HandleUdfField = (event, index) => {
    // Helper function to update Table3
    const updateTable3 = (value) => {
      setAllClientCardData((prevData) => ({
        ...prevData,
        Table3: prevData?.Table3.map((item) =>
          item.UserDefFieldID === index ? { ...item, UdfValue: value } : item
        ),
      }));
    };

    if (event?.target?.value || event?.target?.id) {
      // Handle text or dropdown fields
      const { value, innerHTML } = event.target;
      const fieldValue =
        (value && value.trim()) || (innerHTML && innerHTML.trim());

      updateTable3(fieldValue);
      HandleUdfFieldChange(fieldValue, index);
    } else if (event) {
      // Handle date fields
      const formattedDate = dayjs(event).format("DD/MM/YYYY");
      console.log("Selected date:", formattedDate);

      // Update the value in Table3
      updateTable3(formattedDate);
      HandleUdfFieldChange(formattedDate, index);
    }
  };

  const HandleUdfFieldChange = (fieldValue, index) => {
    setUdfFieldChange((prevData) => {
      // Find the matching field from Table3
      const matchedField = allClientCardData?.Table3.find(
        (item) => item?.UserDefFieldID === index
      );

      if (!matchedField) {
        console.error("Field not found in Table3");
        return prevData; // Return unchanged state if the field is not found
      }

      // Update the matched field with the new UdfValue
      const updatedField = { ...matchedField, UdfValue: fieldValue };

      if (prevData.length > 0) {
        // Check if the folder exists in udfFieldChange
        const folderIndex = prevData.findIndex(
          (item) => item.folderId === folderId?.FolderID
        );

        if (folderIndex !== -1) {
          // Folder exists; update or add the field
          const updatedFolder = {
            ...prevData[folderIndex],
            field: prevData[folderIndex].field.some(
              (field) => field.UserDefFieldID === index
            )
              ? prevData[folderIndex].field.map((field) =>
                  field.UserDefFieldID === index
                    ? updatedField // Update the field
                    : field
                )
              : [...prevData[folderIndex].field, updatedField], // Add the field
          };

          // Return updated state with the modified folder
          return prevData.map((item, i) =>
            i === folderIndex ? updatedFolder : item
          );
        }
      }

      // Add a new folder entry if it doesn't exist
      return [
        ...prevData,
        {
          folderId: folderId?.FolderID,
          field: [updatedField],
        },
      ];
    });
  };

  const HandleUdfSwitch = (event, id) => {
    const { checked } = event.target;

    // Update the state immutably
    setAllClientCardData((prevData) => ({
      ...prevData,
      Table3: prevData.Table3.map((item) =>
        item.UserDefFieldID === id
          ? { ...item, blnProcess: checked } // Toggle blnProcess for the matched item
          : item
      ),
    }));
  };

  const HandleFolderChange = (event, value) => {
    if (value) {
      setAllClientCardData([]);
      setFolderId(value);
    }
  };

  const handleChMadalClose = () => {
    setChModalOpen(!chModalOpen);
  };

  return (
    <>
      <Box>
        <Grid container rowSpacing={2} columnSpacing={3}>
          <Grid item xs={12} sm={12} md={6}>
            <Accordion defaultExpanded>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <Typography variant="h6" clasName="lato-semibold title">
                  Company Details
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container rowSpacing={2} columnSpacing={3}>
                  <Grid item xs={12} sm={12} md={12} lg={6} xl={6} xxl={6}>
                    <TextField
                      className="w-100"
                      label="ID"
                      id="outlined-size-small"
                      size="small"
                      sx={{ marginRight: 1 }}
                      required
                      name="ID"
                      value={CompanyFormData.ID}
                      onChange={handleTextFieldChange}
                    />
                  </Grid>
                  {/* Ch number */}
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6} xxl={6}>
                    <Box clasName="d-flex flex-column ">
                      <Typography>Ch Number</Typography>
                      <AcUnitIcon onClick={handleChMadalClose} />
                    </Box>
                    {/* <TextField
                      className="w-100"
                      label="CH Number"
                      id="outlined-size-small"
                      size="small"
                      sx={{ marginRight: 1 }}
                      name="CH_Number"
                      // value={CompanyFormData.ID}
                      onChange={handleTextFieldChange}
                      InputProps={{
                        readOnly: true, // Makes the field read-only
                      }}
                    /> */}
                  </Grid>

                  {/* Attach Id */}
                  <Grid item xs={12} sm={6} md={12} lg={6}>
                    <Box className="d-flex align-items-center ms-3">
                      <Typography>Attach ID</Typography>
                      <Checkbox
                        checked={isChecked}
                        onChange={handleCheckboxChange}
                      />
                    </Box>
                  </Grid>
                  {/* Name */}
                  <Grid item xs={12} sm={12} md={12} lg={6} xl={6} xxl={6}>
                    <TextField
                      fullWidth
                      label="Name"
                      id="outlined-size-small"
                      size="small"
                      value={CompanyFormData?.Name}
                      name="Name"
                      onChange={handleChange}
                      required
                    />
                  </Grid>
                  {/* Business list */}
                  <Grid item xs={12} sm={12} md={12} lg={6} xl={6} xxl={6}>
                    <Box className="custom-autocomplete">
                      <AutoComplete
                        ComData={bussiness}
                        defaultValue={CompanyFormData.Business}
                        target="BussName"
                        comFun={(e, newValue) => {
                          setCompanyFormData({
                            ...CompanyFormData,
                            Business: newValue,
                          });
                        }}
                        lable="Business"
                        required
                      ></AutoComplete>
                    </Box>
                  </Grid>
                  {/* status */}
                  <Grid item xs={12} sm={12} md={12} lg={6} xl={6} xxl={6}>
                    <Box className="custom-autocomplete">
                      <AutoComplete
                        ComData={companyStatus}
                        defaultValue={
                          CompanyFormData?.status
                            ? CompanyFormData?.status
                            : "Active"
                        }
                        target="StatusName"
                        comFun={(e, newValue) => {
                          setCompanyFormData({
                            ...CompanyFormData,
                            status: newValue,
                          });
                        }}
                        lable="Status"
                      ></AutoComplete>
                    </Box>
                  </Grid>
                  {/* Source */}
                  <Grid item xs={12} sm={12} md={12} lg={6} xl={6} xxl={6}>
                    <Box className="custom-autocomplete">
                      <AutoComplete
                        ComData={sources}
                        defaultValue={
                          CompanyFormData?.Source ? CompanyFormData?.Source : ""
                        }
                        target="SourceName"
                        comFun={(e, newValue) => {
                          setCompanyFormData({
                            ...CompanyFormData,
                            Source: newValue,
                          });
                        }}
                        lable="Source"
                      ></AutoComplete>
                    </Box>
                  </Grid>
                  {/* Manager */}
                  <Grid item xs={12} sm={12} md={12} lg={6} xl={6} xxl={6}>
                    <Box className="custom-autocomplete">
                      <AutoComplete
                        ComData={mangers}
                        defaultValue={
                          CompanyFormData?.Manager
                            ? CompanyFormData?.Manager
                            : ""
                        }
                        target="UserName"
                        comFun={(e, newValue) => {
                          setCompanyFormData({
                            ...CompanyFormData,
                            Manager: newValue,
                          });
                        }}
                        lable="Manager"
                      ></AutoComplete>
                    </Box>
                  </Grid>

                  <Grid item xs={12} sm={12} md={12} lg={6} xl={6} xxl={6}>
                    <Box className="custom-autocomplete">
                      <Autocomplete
                        multiple
                        size="small"
                        options={GetFolders}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option.Folder}
                        isOptionEqualToValue={(option, value) =>
                          option.FolderID === value.FolderID
                        }
                        defaultValue={
                          FolderIdtolabel &&
                          Object.keys(FolderIdtolabel).length > 0
                            ? FolderIdtolabel
                            : selectedFolders
                        }
                        renderOption={(props, option, { selected }) => (
                          <li {...props}>
                            <Checkbox
                              style={{ marginRight: 8 }}
                              checked={selectedFolders?.some(
                                (selected) =>
                                  selected.FolderID === option.FolderID
                              )}
                            />
                            {option?.Folder}
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Folder"
                            placeholder="Select folders"
                          />
                        )}
                        onChange={(e, v) => handleChange1(v)}
                        value={selectedFolders}
                      />
                    </Box>
                  </Grid>

                  <Grid item xs={12} sm={12} md={12} lg={6} xl={6} xxl={6}>
                    <TextField
                      className="w-100"
                      fullWidth
                      label="Email"
                      id="outlined-size-small"
                      size="small"
                      required
                      name="contactEmail"
                      value={CompanyFormData.contactEmail}
                      onChange={handleEmailChange1}
                      error={!!emailError}
                      helperText={emailError}
                    />
                  </Grid>

                  <Grid item xs={12} sm={12} md={12} lg={6} xl={6} xxl={6}>
                    <TextField
                      fullWidth
                      label="MobileNo"
                      id="outlined-size-small"
                      size="small"
                      name="MobileNo"
                      value={CompanyFormData.MobileNo}
                      onChange={handleFnameInputChange}
                    />
                  </Grid>

                  <Grid item xs={12} sm={12} md={12} lg={6} xl={6} xxl={6}>
                    <TextField
                      fullWidth
                      label="TelePhone No"
                      id="outlined-size-small"
                      size="small"
                      name="TelPhoneNo"
                      value={CompanyFormData.TelPhoneNo}
                      onChange={handleFnameInputChange}
                    />
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>
          </Grid>

          <Grid item xs={12} sm={12} md={6}>
            <Accordion defaultExpanded>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <Typography variant="h6" clasName="lato-semibold title">
                  Edit Company Address
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Box sx={{ width: "100%" }}>
                  <Box
                    sx={{ width: "100%", typography: "body1" }}
                    className="custom-tabs"
                  >
                    <TabContext value={tabValue}>
                      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                        <TabList
                          onChange={handleTabChange}
                          aria-label="Address Tabs"
                          className="mb-3 flex-wrap-tabs"
                        >
                          {TabListData.map((tab, index) => (
                            <Tab
                              key={index}
                              label={tab?.tabTile}
                              value={`${index + 1}`}
                            />
                          ))}
                          <Tab label="Full Address" value={`4`} />
                        </TabList>
                      </Box>

                      {TabListData &&
                        TabListData.map((address, index) => {
                          let selectedCountry;
                          return (
                            <TabPanel
                              key={index}
                              value={`${index + 1}`}
                              className="p-0 mt-"
                            >
                              <Grid container rowSpacing={2} columnSpacing={3}>
                                <Grid item xs={12} sm={12} md={12} lg={6}>
                                  <TextField
                                    fullWidth
                                    label="Address 1"
                                    size="small"
                                    value={allAddressData[index]?.Add1 || ""}
                                    onChange={(e) =>
                                      onHandleChange(e, index, "Add1")
                                    }
                                    required
                                  />
                                </Grid>

                                <Grid item xs={12} sm={12} md={12} lg={6}>
                                  <TextField
                                    fullWidth
                                    label="Address 2"
                                    size="small"
                                    value={allAddressData[index]?.Add2 || ""}
                                    onChange={(e) =>
                                      onHandleChange(e, index, "Add2")
                                    }
                                    required
                                  />
                                </Grid>

                                <Grid item xs={12} sm={12} md={12} lg={6}>
                                  <TextField
                                    fullWidth
                                    label="Address 3"
                                    size="small"
                                    value={allAddressData[index]?.Add3 || ""}
                                    onChange={(e) =>
                                      onHandleChange(e, index, "Add3")
                                    }
                                    required
                                  />
                                </Grid>

                                <Grid item xs={12} sm={12} md={12} lg={6}>
                                  <TextField
                                    fullWidth
                                    label="Town"
                                    size="small"
                                    value={allAddressData[index]?.Town || ""}
                                    onChange={(e) =>
                                      onHandleChange(e, index, "Town")
                                    }
                                  />
                                </Grid>

                                <Grid item xs={12} md={12} lg={6}>
                                  <TextField
                                    fullWidth
                                    label="County"
                                    size="small"
                                    value={allAddressData[index]?.County || ""}
                                    onChange={(e) =>
                                      onHandleChange(e, index, "County")
                                    }
                                  />
                                </Grid>

                                <Grid item xs={12} md={12} lg={6}>
                                  <TextField
                                    fullWidth
                                    label="Postcode"
                                    size="small"
                                    value={
                                      allAddressData[index]?.Postcode || ""
                                    }
                                    onChange={(e) =>
                                      onHandleChange(e, index, "Postcode")
                                    }
                                  />
                                </Grid>

                                <Grid item xs={12} md={12} lg={6}>
                                  <Box className="custom-autocomplete">
                                    <AutoComplete
                                      ComData={CountryList}
                                      target="label"
                                      defaultValue={
                                        allAddressData[index]?.Country || ""
                                      }
                                      comFun={(e, newValue) => {
                                        setAllAddressData((prevData) =>
                                          prevData.map((addr, i) =>
                                            i === index
                                              ? {
                                                  ...addr,
                                                  Country:
                                                    newValue?.label || "",
                                                }
                                              : addr
                                          )
                                        );
                                      }}
                                      lable="Country"
                                    />
                                  </Box>
                                </Grid>
                              </Grid>
                            </TabPanel>
                          );
                        })}

                      <TabPanel value="4" className="p-0 mt-">
                        <TextField
                          className="w-100"
                          label="Full Address"
                          id="outlined-multiline-static"
                          multiline
                          rows={7}
                          variant="outlined"
                          value={description}
                          onChange={(e) => setDescription(e.target.value)}
                          sx={{ marginTop: 2 }}
                          inputProps={{
                            readOnly: true,
                          }}
                        />
                      </TabPanel>
                    </TabContext>
                  </Box>
                </Box>
              </AccordionDetails>
            </Accordion>
          </Grid>
        </Grid>

        <Box
          sx={{
            border: "1px solid #DDDDDD",
            borderRadius: "10px",
            padding: "10px 20px 20px 20px",
            marginTop: "20px",
          }}
        >
          <Typography variant="h6" className="lato-semibold mb-2 title">
            Add Contact
          </Typography>
          <CreateContect
            formData={contactFormData}
            setformData={setContactFormData}
            manager={manager}
            setManager={setManager}
            rolestest={roles}
            OriginatorNo={CompanyFormData.ID ? CompanyFormData.ID : ""}
          />
        </Box>

        <Grid container rowSpacing={2} columnSpacing={3} className="mt-4">
          <Grid item xs={12} className="mb-2">
            <div className="d-flex flex-column">
              <Typography className="mb-3 lato-semibold title" variant="h6">
                UDF Field
              </Typography>
              {Array.isArray(selectedFolders) &&
                selectedFolders?.length > 1 && (
                  <Box className="custom-autocomplete">
                    <AutoComplete
                      ComData={selectedFolders}
                      target="Folder"
                      comFun={HandleFolderChange}
                      lable={"Folder"}
                      defaultValue={folderId}
                    />
                  </Box>
                )}
            </div>            
          </Grid>
          {allClientCardData &&
              allClientCardData?.Table?.length > 0 &&
              allClientCardData?.Table?.map((udfTable, index) => (
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6} xxl={6}>
                  <Accordion className="accordian-box">
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1-content"
                      id="panel1-header"
                      spacing={2}
                    >
                      <Typography expandIcon={<ExpandMoreIcon />}>
                        {udfTable?.TagName}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails className="py-4">
                      <Grid container spacing={2}>
                        {allClientCardData?.Table3.length > 0 ? (
                          allClientCardData?.Table3.some(
                            (udfFieId) => udfTable?.TagId === udfFieId.Tag
                          ) ? (
                            allClientCardData?.Table3.map(
                              (udfFieId, index) =>
                                udfTable?.TagId === udfFieId.Tag && (
                                  <Grid item xs={12} md={12} key={index}>
                                    <Box className="d-flex gap-2">
                                      <Box className="d-flex gap-2 align-items-center">
                                        <Tooltip
                                          title={udfFieId?.Name}
                                          slots={{
                                            transition: Zoom,
                                          }}
                                          arrow
                                        >
                                          <IconButton>
                                            <InfoIcon />
                                          </IconButton>
                                        </Tooltip>
                                        <Typography className="">
                                          {udfFieId?.Name}
                                        </Typography>
                                      </Box>
                                      <Switch
                                        checked={udfFieId?.blnProcess}
                                        name={`blnProcess-${udfFieId?.UserDefFieldID}`}
                                        onChange={(e) =>
                                          HandleUdfSwitch(
                                            e,
                                            udfFieId?.UserDefFieldID
                                          )
                                        }
                                      />
                                      <UserUdfEditField
                                        udfFieId={udfFieId}
                                        changeFun={HandleUdfField}
                                      />
                                    </Box>
                                  </Grid>
                                )
                            )
                          ) : (
                            <Grid item xs={12}>
                              <Typography>No data found</Typography>
                            </Grid>
                          )
                        ) : (
                          <Grid item xs={12}>
                            <Typography>No data found</Typography>
                          </Grid>
                        )}
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                </Grid>
              ))}
        </Grid>
      </Box>

      {/* Ch modal */}
      <Dialog
        open={chModalOpen}
        onClose={handleChMadalClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="custom-modal modal-md"
        fullWidth={true}
        maxWidth={"md"}
      >
        <Box className="d-flex align-items-center justify-content-between modal-head">
          <Box className="clearfix">
            <DialogTitle>U.K. Companies House Search</DialogTitle>
          </Box>

          <Button onClick={handleChMadalClose} autoFocus>
            <CloseIcon />
          </Button>
        </Box>

        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            style={{ minHeight: 300, maxHeight: 500 }}
          >
            <CompanyChModal
              handleClose={handleChMadalClose}
              setCompanyFormData={setCompanyFormData}
              setContactFormData={setContactFormData}
              setAllAddressData={setAllAddressData}
            />
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default CreateNewComoany;

const top100Films = [
  { label: "The Shawshank Redemption", year: 1994 },
  { label: "The Godfather", year: 1972 },
  { label: "The Godfather: Part II", year: 1974 },
  { label: "The Dark Knight", year: 2008 },
];
